import * as types from '../actions/ActionTypes';
import { assign } from '../../../shared/Assign';
import InitialState from './InitialState';

export default function templateReducer(
    state: any = InitialState.templates,
    action: { type: string; result: any }
) {
    let newState = assign({}, state);

    switch (action.type) {
        case types.GET_TEMPLATE_LIST_SUCCESS:
            newState.list = action.result;
            return newState;
        case types.EDIT_TEMPLATE_SUCCESS:
            newState.edit = action.result;
            return newState;
        case types.UPDATE_TEMPLATE_SUCCESS:
            return newState;
        default:
            return state;
    }
}
